import { useContext, useEffect } from 'react';
import { VulnDrawerTabsContext } from '../NRVulnerabilitiesTable/NRVulnerabilityDetails/NRVulnerabilityDetails';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Box from '@mui/material/Box';
import NRCollapsibleComponent from '../NRCollapsibleComponent/NRCollapsibleComponent';
import NRShowMore from '../NRShowMore/NRShowMore';
import NRTitleWithRightTotal from '../NRRightTotal/NRRightTotal';
import NRHashFile from './NRHashFile/NRHashFile';
import NRNoData from '../NRDependencies/NRNoData/NRNoData';
import React from 'react';
import { CONSTANTS } from '../../constants/constants';
import { FiltersContext } from '../../pages/NRReportTabs/NRReportFilterContextWrapper';
import NRLoader from '../NRLoader/NRLoader';
import NRShortenFilePath from '../NRReactGridCustomComponents/NRCustomProviders/NRShortenFilePath/NRShortenFilePath';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeTabAndSubTabFromFilePath } from '../../services/urlInterceptor.utils';
import { useTheme } from '@mui/material/styles';

function NRAssociatedFiles({ threshold, scrollTarget, index, scrollableId, context, associatedFiles, title, isLoading }) {
  const theme = useTheme();
  const { setScrollSpyTabsValue } = useContext(context || VulnDrawerTabsContext);
  const { setOpenDrawer } = useContext(FiltersContext);
  const navigate = useNavigate();
  const location = useLocation();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold,
    target: !!scrollTarget ? scrollTarget : undefined
  });

  useEffect(() => {
    setScrollSpyTabsValue(index, trigger);
  }, [trigger]);

  const handleOnClick = value => {
    let extraParams = new URLSearchParams();
    extraParams.append('filePath', value);
    navigate(`${removeTabAndSubTabFromFilePath(location)}/${CONSTANTS.REPORT.TABS.FILE_SYSTEM}?${extraParams.toString()}`);
    setOpenDrawer(false);
  };

  return (
    <Box id={scrollableId} mt={theme.spacing(3)}>
      <NRTitleWithRightTotal totalCount={associatedFiles?.length || 0} title={title} />
      {isLoading ? (
        <Box sx={{ height: '120px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <NRLoader />
        </Box>
      ) : (
        <>
          {!!associatedFiles.length && (
            <NRShowMore
              maxHeight={300}
              items={associatedFiles?.map((file, i) => (
                <React.Fragment key={`${file.component?.name}-${i}`}>
                  <NRCollapsibleComponent
                    titleExtraStyles={{ textDecoration: 'none', color: theme.palette.blue.link, cursor: 'default' }}
                    title={file.component?.name}
                    titleComponent={
                      <NRShortenFilePath
                        filePath={file.component?.name}
                        shouldDisplayLink={true}
                        onClickLink={() => handleOnClick(file.component?.name)}
                      />
                    }
                    openByDefault={false}
                    collapsibleContent={<NRHashFile file={file.component} />}
                    titleWidth={'unset'}
                  />
                </React.Fragment>
              ))}
            />
          )}
          {!associatedFiles?.length && <NRNoData noDataTitle={title} />}
        </>
      )}
    </Box>
  );
}

export default NRAssociatedFiles;
